import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    close: (theme) => ({
        backgroundColor: theme.colors.black,
        borderRadius: '50%',
        height: 35,
        minWidth: 35,
        opacity: 0.6,
        padding: '0 !important',
        position: 'absolute',
        right: 36,
        top: 20,
        width: 35,
        zIndex: 1
    }),

    modal: (theme) => ({
        '&:focus-visible': {
            outline: `2px solid ${theme.colors.teal}`,
            outlineOffset: -2
        },
        backgroundColor: theme.colors.white,
        borderRadius: 4,
        maxHeight: 'calc(100dvh - 32px)',
        overflowY: 'auto',
        scrollPaddingTop: 64,
        width: '100%'
    }),

    wrapper: {
        boxSizing: 'border-box',
        left: '50%',
        maxWidth: 632,
        outline: 0,
        position: 'absolute',
        px: 2,
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%'
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
